import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'
import NewValuePropositionBig from '../HomePage/MainHeadlineContent/components/NewValuePropositionBig'
import {
  APPOINTMENT_DESCRIPTION_REGIONAL_DETAILS,
  APPOINTMENT_ALT,
  OIL_CHANGE_ALT,
  VIEW_SPECIALS_ALT,
  SHOP_TIRES_ALT,
  SERVICES_ALT,
  SERVICES_TITLE,
  OIL_CHANGE_TITLE,
  VIEW_SPECIALS_TITLE,
  REGIONAL_DEALS_BOOK_APPOINTMENT,
  REGIONAL_DEALS_OIL_CHANGE,
  REGIONAL_DEALS_SPECIALS,
  REGIONAL_DEALS_SHOP_TIRES,
  REGIONAL_DEALS_SERVICES
} from 'components/BOTRegionalDetails/constants'
import NewValuePropositionSmall from '../HomePage/MainHeadlineContent/components/NewValuePropositionSmall'
import { PROMOTIONS_PAGE, SERVICES_PAGE } from 'constant'
import { SHOP_TIRES_TITLE } from '../HomePage/MainHeadlineContent/constant'

const BOTRegionalDetails = ({
  appointmentTitle,
  regionName,
  featuredContent,
  hover: {
    oilChange,
    appointment,
    specials,
    shopTires,
    services
  },
  onClick = () => {},
  oilChangeClick = () => {},
  handleShopByVehicleClick = () => {},
  ...props
}) =>
  <>
    <Wrapper>
      <Title className="regional-deals-title" headline>Regional deals in { regionName }</Title>
      <TilesWrapper>
        <LargeTile
          className={ REGIONAL_DEALS_BOOK_APPOINTMENT }
          asset={ appointment ? 'book-appointment-white' : 'book-appointment-red' }
          title={ appointmentTitle }
          description={ APPOINTMENT_DESCRIPTION_REGIONAL_DETAILS }
          alt={ APPOINTMENT_ALT }
          isHover={ appointment }
          click={ onClick }
          { ...props } />
        <SmallTile
          className={ REGIONAL_DEALS_OIL_CHANGE }
          asset={ oilChange ? 'oil-change-white' : 'oil-red' }
          title={ OIL_CHANGE_TITLE }
          click={ oilChangeClick }
          alt={ OIL_CHANGE_ALT }
          { ...props } />
        <SmallTileSpecials
          className={ REGIONAL_DEALS_SPECIALS }
          asset={ specials ? 'view-specials-white' : 'special-offers' }
          title={ VIEW_SPECIALS_TITLE }
          link={ PROMOTIONS_PAGE }
          alt={ VIEW_SPECIALS_ALT }
          { ...props } />
        <SmallTileTires
          className={ REGIONAL_DEALS_SHOP_TIRES }
          asset={ shopTires ? 'tire-white' : 'tire-bright-red' }
          title={ SHOP_TIRES_TITLE }
          click={ handleShopByVehicleClick }
          alt={ SHOP_TIRES_ALT }
          { ...props } />
        <SmallTileServices
          className={ REGIONAL_DEALS_SERVICES }
          asset={ services ? 'view-services-white' : 'services' }
          title={ SERVICES_TITLE }
          link={ SERVICES_PAGE }
          alt={ SERVICES_ALT }
          { ...props } />
      </TilesWrapper>
    </Wrapper>
    <HTMLContainer content={ featuredContent } />
  </>

BOTRegionalDetails.propTypes = {
  appointmentTitle: PropTypes.string,
  featuredContent: PropTypes.string,
  handleShopByVehicleClick: PropTypes.func,
  hover: PropTypes.shape({
    oilChange: PropTypes.bool,
    appointment: PropTypes.bool,
    shopTires: PropTypes.bool,
    specials: PropTypes.bool,
    services: PropTypes.bool
  }),
  oilChangeClick: PropTypes.func,
  onClick: PropTypes.func,
  regionName: PropTypes.string
}

export default BOTRegionalDetails

const Wrapper = styled.div`
  ${Mixin.responsive('margin', '0', '0 8px 0')}
`

const TilesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2%;
  width: 100%;
  max-height: 206px;
  padding: 35px 0 45px;
  ${Media.mobile`
    display: grid;
    grid-template:
      'appointment appointment'
      'oil-change specials'
      'tires services';
    place-items: center;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 20px;
    max-height: unset;
    padding: 23px 10px;
  `}
`

const LargeTile = styled(NewValuePropositionBig)`
  max-width: 460px;
  margin: 0;

  & .main-icon-wrapper {
    width: fit-content;
  }

  & .main-icon {
    width: 50px;
    height: 50px;
  }

  & .tile-title {
    margin-bottom: 8px;
  }

  @media (max-width: 1400px) {
    padding: 34px 32px 32px 20px;

    & .tile-text-wrapper {
      margin-left: 10px;
    }

    & .tile-title {
      font-size: 18px;
    }
  }

  ${Media.mobile`
    grid-area: appointment;
    max-width: unset;
    padding: 16px 20px;

    & .tile-title {
      margin-bottom: 3px;
    }

    & .main-icon {
      width: 34px;
      height: 34px;
    }

    & .tile-description {
      max-width: 200px;
    }
  `}

  @media (max-width: 450px) {
    padding: 20px 20px 21px;

    & .tile-title {
      font-size: 17px;
    }
  }

  @media (max-width: 360px) {
    padding: 23px 20px;

    & .tile-title {
      font-size: 14px;
    }
  }
`

const SmallTile = styled(NewValuePropositionSmall)`
  padding: 14px;

  & .small-tile-title {
    margin: 19px 0 0 0;
  }

  & .small-tile-icon-wrapper {
    height: auto;
    width: auto;
  }

  & .small-tile-icon {
    height: 54px;
  }

  @media (max-width: 1290px) {
    width: 42%;
    padding: 14px 7px;

    & .small-tile-title {
      font-size: 14px;
    }
  }

  ${Media.mobile`
    grid-area: oil-change;
    width: 100%;
    padding: 15px 10px 16px;

    & .small-tile-icon {
      height: 30px;
      width: 30px;
    }
  `}

  @media (max-width: 360px) {
    & .small-tile-title {
      font-size: 13px;
    }
  }
`

const SmallTileSpecials = styled(SmallTile)`
  ${Media.mobile`
    grid-area: specials;
  `}
`

const SmallTileTires = styled(SmallTile)`
  ${Media.mobile`
    grid-area: tires;
  `}
`

const SmallTileServices = styled(SmallTile)`
  ${Media.mobile`
    grid-area: services;
  `}
`

const Title = styled.h1`
  float: left;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(26, 600)}
  ${Mixin.responsive('margin', '0 0 14px', '0 8px 20px 8px')}
  ${Media.mobile`
    ${Mixin.font.GothamBold(20, 600)}
  `}
`
